import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showBulkUpdateModal } from 'store/Contextualization/AssetDetail/actions';
import CopyLink from './components/CopyLink';
import CopyApiLink from './components/CopyApiLink';
import { Wrapper, InputTitle, IconVulnerability } from './styled';
import { selectDetail } from 'store/Contextualization/AssetDetail/selectors';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { useIntl } from 'react-intl';

const Title = () => {
  const dispatch = useDispatch();
  const vulnDetail = useSelector((state) => selectDetail('vulns', state));
  const [vulnName, setVulnName] = useState(vulnDetail.name);
  const readOnly = useSelector(selectIsReadOnly);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'manage.cm.edit.name' });

  useEffect(() => {
    setVulnName(vulnDetail.name);
  }, [vulnDetail]);

  const handleChange = (e) => {
    const name = e.target.value;
    dispatch(showBulkUpdateModal('name', name));
  };

  return (
    <Wrapper>
      <IconVulnerability />
      <InputTitle title={ title } value={ vulnName } onClick={ handleChange } disabled={ readOnly || !allowedByRole } />
      <CopyLink />
      <CopyApiLink />
    </Wrapper>
  );
};

export default Title;
